module.exports = " <div class=mdt-offers-upperwrap _v-12ed35bc=\"\"> <market-section :title=service.name section-type=hotels _v-12ed35bc=\"\"></market-section> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-12ed35bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offers/services.vue
// module id = 404
// module chunks = 0